import { render, staticRenderFns } from "./returnOrder.vue?vue&type=template&id=a23dc79a&scoped=true&"
import script from "./returnOrder.vue?vue&type=script&lang=js&"
export * from "./returnOrder.vue?vue&type=script&lang=js&"
import style0 from "./returnOrder.vue?vue&type=style&index=0&id=a23dc79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23dc79a",
  null
  
)

export default component.exports